module.exports = __webpack_public_path__ + "static/img/MV21.3b73f94.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/MV21.jpg
// module id = bbNI
// module chunks = 0